<template>
  <hr class="[&:not(:first-child)]:mt-6">
</template>
